"use client";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body style={{ fontFamily: "monospace", padding: "2rem" }}>
        <h1>Erreur serveur</h1>
        <pre style={{ whiteSpace: "pre-wrap", color: "red" }}>
          {error.message}
        </pre>
        {error.digest && <p>Digest: {error.digest}</p>}
      </body>
    </html>
  );
}
